module.exports = __webpack_public_path__ + "img/Unidad20-1.40c45a48.png";